
import { useSearchParams } from "react-router-dom";

import { useState } from "react";
import { FilledButton } from "../components/common/Button";
import useRouting from "../hooks/useRouting";
import { BRAND_ASSETS } from "../config/defaultAssetUrls";
import TextInputField from "../components/common/TextInputField";
import { validPassword } from "../utils/regularExpressions";
import useAuth from "../hooks/useAuth";
import useGlobalLoading from "../hooks/useGlobalLoading";

const ResetPasswordPage: React.FC = () => {

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const { goToLoginFreelancers } = useRouting();
    const { error, loading, changePasswordByToken, logout } = useAuth();
    const { setLoading } = useGlobalLoading();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [successMessage, setSuccessMessage] = useState('');


    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        setPasswordError('');
        setConfirmPasswordError('');


        if (!password) {
            setPasswordError('Password is required');
            return;
        }

        if (!validPassword(password)) {
            setPasswordError('Password requirements: 8 characters, at least 1 character and 1 number');
            return;
        }

        if (!confirmPassword) {
            setConfirmPasswordError('Confirm password is required');
            return;
        }

        if (password !== confirmPassword) {
            setConfirmPasswordError('Passwords do not match');
            return;
        }

        // Reset password
        setLoading(true);
        changePasswordByToken(token, password).then(
            (res) => {
                setPassword('');
                setConfirmPassword('');
                setPasswordError('');
                setConfirmPasswordError('');
                logout(); // just safety - delete cookies etc in case they currently exist
                setSuccessMessage('Password successfully changed.');
            }
        ).catch(
            (err) => {
            }
        ).finally(() => {
            setLoading(false);
        });
    }


    return (
        <div className="h-screen flex justify-center p-20">
            <div className="flex flex-col items-center">
                <img
                    src={BRAND_ASSETS.LOGO}
                    alt="Gamershome Logo"
                    className="w-80"
                />

                <h4 className="my-4">Change Password</h4>

                {!successMessage
                    ? <form
                        className="flex flex-col space-y-4"
                        onSubmit={handleSubmit}>
                        <TextInputField
                            type="password"
                            id="password"
                            label="New Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            error={passwordError}
                        />
                        <TextInputField
                            type="password"
                            id="confirmPassword"
                            label="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            error={confirmPasswordError}
                        />
                        <FilledButton
                            fullWidth
                            isLoading={loading}
                        >
                            Reset Password
                        </FilledButton>
                        {error && <p className="text-danger text-center mt-4">{error}</p>}
                    </form>
                    : <div>
                        <p className="text-success text-center">{successMessage}</p>
                        <FilledButton onClick={goToLoginFreelancers}>
                            Continue to Login
                        </FilledButton>
                    </div>}
            </div>

        </div>
    );
};

export default ResetPasswordPage;